import React from "react";
import withStyles from "react-jss";
import classNames from "classnames";

const styles = (theme) => ({
	root: {
		display: "flex",
		justifyContent: "center",
		marginBottom: "40px",
	},
	stub: {
		height: "630px",
		width: "280px",
		userSelect: "none",
		lineHeight: "1",
		borderRadius: "10px",
		border: "solid 1px " + theme.palette.colors.disabled,
		letterSpacing: "2.3px",
		display: "inline-flex",
		justifyContent: "center",
		alignItems: "center",
		backgroundColor: theme.palette.colors.disabled,
	},

	[`@media (max-width: ${theme.media.sm})`]: {},
});

const StubAntiFilter = (props) => {
	let classes = props.classes;
	return (
		<div className={classNames(classes.root)}>
			<div className={classNames(classes.stub)} />
		</div>
	);
};

export default withStyles(styles)(StubAntiFilter);
